import React from 'react';
import Paper from '@material-ui/core/Paper';
import { Redirect } from 'react-router-dom';
import styles from './SignIn.module.scss';
import EmailLogin from './EmailLogin';
import { useStoreState } from '~/store/hooks';
import { SIGN_IN_MFA } from '~/ui/constants/paths';

const SignIn = () => {
  const isMfaRequired = useStoreState(store => store.auth.isMfaRequired);

  if (isMfaRequired) {
    return <Redirect to={SIGN_IN_MFA} />;
  }

  return (
    <Paper elevation={3} className={styles.signIn}>
      <EmailLogin />
    </Paper>
  );
};

export default SignIn;
